import DeleteModal from 'modules/myAdvertisment/myAdvertisment/deleteModal';
import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
interface ManageAdProps {
  status: 'published' | 'rejected' | 'pending';
  app: 'farm' | 'wholesaler';
  guid: string;
  type: 'post';
  cardType: string;
  post: IGetMyWantedsResults;
  refetch: () => void;
}
const ManageAd = ({status, app, type, guid, post, refetch}: ManageAdProps) => {
  const navigate = useNavigate();
  const [isOpenModalDelete, setIsOpenModalDelete] = useState(false);

  return (
    <div className="w-full h-full flex justify-end items-end">
      {status === 'published' && (
        <button
          className="text-primary  font-normal text-[13px]"
          onClick={() => navigate(`/${app}/my-advertisment/detail/${guid}`)}
        >
          مدیریت آگهی
        </button>
      )}
      {status === 'rejected' && (
        <div className="flex w-full justify-around gap-2  font-normal text-[13px]">
          <button className="text-primary">رفع نواقص </button>
          <button
            className="text-error"
            onClick={() => setIsOpenModalDelete(prev => !prev)}
          >
            حذف آگهی
          </button>
        </div>
      )}
      <DeleteModal
        refetch={refetch}
        setIsopen={setIsOpenModalDelete}
        app={app}
        isOpen={isOpenModalDelete}
        delete_reason="canceled"
        type={type}
        guid={guid}
      />
    </div>
  );
};

export default ManageAd;
